/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SubscriptionStateEnum } from './subscriptionStateEnum';


export interface SubscriptionDisplayCreationPostSpec { 
    tenantId: string;
    serialNumber: string;
    startDate: string;
    endDate: string;
    quantity: number;
    state: SubscriptionStateEnum;
    chargeId: string;
    datacenter: string;
    serviceType: string;
}
export namespace SubscriptionDisplayCreationPostSpec {
}


